
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import { ExcelTemplateConfig } from "./types";
export const downloadExcelTemplate = async (config: ExcelTemplateConfig) => {
  const workbook = new ExcelJS.Workbook();

  workbook.creator = "Aupertz";
  workbook.created = new Date();

  const worksheet = workbook.addWorksheet(config.sheetName);

  worksheet.columns = config.columns;

  // Header Style
  worksheet.getRow(1).eachCell((cell) => {
    cell.font = { bold: true, color: { argb: "FFFFFFFF" } };
    cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "1F4E78" } };
    cell.alignment = { horizontal: "center", vertical: "middle" };
    cell.border = {
      top: { style: "thin" },
      left: { style: "thin" },
      right: { style: "thin" },
      bottom: { style: "thin" },
    };
  });

  // Freeze Header
  worksheet.views = [{ state: "frozen", ySplit: 1 }];

  // Dropdowns
  if (config.dropdowns?.length) {
    config.dropdowns.forEach((dropdown) => {
      const columnIndex =
        config.columns.findIndex((c) => c.key === dropdown.key) + 1;

      if (columnIndex === 0) return;

      const columnLetter = worksheet.getColumn(columnIndex).letter;

      for (let row = 2; row <= 1000; row++) {
        worksheet.getCell(`${columnLetter}${row}`).dataValidation = {
          type: "list",
          allowBlank: false,
          formulae: [`"${dropdown.values.join(",")}"`],
          showErrorMessage: true,
          errorTitle: "Invalid Value",
          error: `Allowed values: ${dropdown.values.join(", ")}`,
        };
      }
    });
  }

  // Dummy/sample data rows — for testing only
  if (config.data?.length) {
    config.data.forEach((row) => {
      worksheet.addRow(row);
    });
  }

  const buffer = await workbook.xlsx.writeBuffer();

  saveAs(new Blob([buffer]), config.fileName);
};


// import ExcelJS from "exceljs";
// import { saveAs } from "file-saver";
// import { ExcelTemplateConfig } from "./types";

// export const downloadExcelTemplate = async (config: ExcelTemplateConfig) => {
//   const workbook = new ExcelJS.Workbook();

//   workbook.creator = "Aupertz";
//   workbook.created = new Date();

//   const worksheet = workbook.addWorksheet(config.sheetName);

//   worksheet.columns = config.columns;

//   // Header Style
//   worksheet.getRow(1).eachCell((cell) => {
//     cell.font = {
//       bold: true,
//       color: {
//         argb: "FFFFFFFF",
//       },
//     };

//     cell.fill = {
//       type: "pattern",
//       pattern: "solid",
//       fgColor: {
//         argb: "1F4E78",
//       },
//     };

//     cell.alignment = {
//       horizontal: "center",
//       vertical: "middle",
//     };

//     cell.border = {
//       top: { style: "thin" },
//       left: { style: "thin" },
//       right: { style: "thin" },
//       bottom: { style: "thin" },
//     };
//   });

//   // Freeze Header

//   worksheet.views = [
//     {
//       state: "frozen",
//       ySplit: 1,
//     },
//   ];

//   // Dropdowns

//   if (config.dropdowns?.length) {
//     config.dropdowns.forEach((dropdown) => {
//       const columnIndex =
//         config.columns.findIndex((c) => c.key === dropdown.key) + 1;

//       if (columnIndex === 0) return;

//       const columnLetter = worksheet.getColumn(columnIndex).letter;

//       for (let row = 2; row <= 1000; row++) {
//         worksheet.getCell(`${columnLetter}${row}`).dataValidation = {
//           type: "list",
//           allowBlank: false,
//           formulae: [`"${dropdown.values.join(",")}"`],
//           showErrorMessage: true,
//           errorTitle: "Invalid Value",
//           error: `Allowed values: ${dropdown.values.join(", ")}`,
//         };
//       }
//     });
//   }

//   const buffer = await workbook.xlsx.writeBuffer();

//   saveAs(new Blob([buffer]), config.fileName);
// };

// import ExcelJS from "exceljs";
// import { saveAs } from "file-saver";

// export const downloadExcelTemplate = async () => {
//   const workbook = new ExcelJS.Workbook();

//   workbook.creator = "Aupertz";
//   workbook.created = new Date();

//   const worksheet = workbook.addWorksheet("Programs");

//   worksheet.columns = [
//     { header: "Account Code *", key: "program_code", width: 20 },
//     { header: "Display Name *", key: "program_name", width: 35 },
//     { header: "Location *", key: "location_name", width: 25 },
//     { header: "Description *", key: "description", width: 40 },
//     { header: "Is Active *", key: "is_active", width: 18 },
//   ];

//   // Header Styling
//   worksheet.getRow(1).eachCell((cell) => {
//     cell.font = {
//       bold: true,
//       color: { argb: "FFFFFFFF" },
//     };

//     cell.fill = {
//       type: "pattern",
//       pattern: "solid",
//       fgColor: { argb: "1F4E78" },
//     };

//     cell.alignment = {
//       vertical: "middle",
//       horizontal: "center",
//     };

//     cell.border = {
//       top: { style: "thin" },
//       left: { style: "thin" },
//       right: { style: "thin" },
//       bottom: { style: "thin" },
//     };
//   });

//   // Add Dropdown (True / False) to Is Active column (E)
//   for (let row = 2; row <= 1000; row++) {
//     worksheet.getCell(`E${row}`).dataValidation = {
//       type: "list",
//       allowBlank: false,
//       formulae: ['"TRUE,FALSE"'],
//       showErrorMessage: true,
//       errorTitle: "Invalid Value",
//       error: "Please select either TRUE or FALSE.",
//     };
//   }

//   // Freeze Header
//   worksheet.views = [
//     {
//       state: "frozen",
//       ySplit: 1,
//     },
//   ];

//   const buffer = await workbook.xlsx.writeBuffer();

//   saveAs(new Blob([buffer]), "Program_Bulk_Upload_Template.xlsx");
// };
